import {
  DESIRED_SUPPORT_KEY,
  type F01StartContext,
} from "@care-by-ella/contracts";

// TES-1321 — "Önskat stöd" in the coach's persisting F-01 start context.
//
// The coach doc ("KANONISKT TILLÄGG 2026-10-13 — ÖNSKAT STÖD SOM COACHENS
// STARTKONTEXT"): "Vyn visar patientens valda etiketter, källa F-01,
// formulärversion och inskickningstidpunkt. Coachen ska kunna öppna
// originalsvaret."
//
// Read from the start context's own answer rows, so the labels are the ones
// she was shown, in the locale she answered in. Pure, so the rules are tested
// without a DOM.
//
// A version before v11 never asked the question. That is not a "no": the F-01
// doc says "avsaknad av den nya datapunkten får inte visas eller analyseras
// som ett negativt svar". So no row means no block, and nothing in its place.

export interface CoachDesiredSupport {
  /** Her chosen labels, verbatim. "Annat" stays "Annat": the text she typed
   *  is in the originals, one click away, not in this summary. */
  labels: string[];
  /** "Källa: F-01 v11 (appen)". */
  source: string;
  /** "Inskickad 2026-10-13 09:41", or null when the time is unknown. */
  submitted: string | null;
}

export function fmtSubmitted(iso: string): string {
  return new Date(iso).toLocaleString("sv-SE", {
    timeZone: "Europe/Stockholm",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function coachDesiredSupport(
  context: F01StartContext | null,
): CoachDesiredSupport | null {
  if (!context || context.status !== "available") return null;
  const row = context.answers.find((a) => a.key === DESIRED_SUPPORT_KEY);
  if (!row || row.access !== "visible" || row.values.length === 0) return null;
  const version =
    context.templateVersion !== null ? ` v${context.templateVersion}` : "";
  const surface = context.source === "lead" ? "webben" : "appen";
  return {
    labels: row.values,
    source: `Källa: F-01${version} (${surface})`,
    submitted: context.submittedAt
      ? `Inskickad ${fmtSubmitted(context.submittedAt)}`
      : null,
  };
}
